import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'
// Stoyan
export const useArchivedProtocols = (projectId: string) => {
  const p = ENDPOINTS.PROTOCOLS.GET_ARCHIVED(projectId)

  const { data, mutate, error } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
